var map = {
	"./Bird_of_Paradise_pollen_01.jpg": 5426,
	"./Bird_of_Paradise_pollen_04.jpg": 9673,
	"./Bird_of_Paradise_pollen_05.jpg": 6123,
	"./Bird_of_Paradise_pollen_06.jpg": 5598,
	"./Cactus_biznaga_red_flower_01.jpg": 2521,
	"./Cactus_biznaga_red_flower_05.jpg": 4938,
	"./Cactus_biznaga_red_flower_06.jpg": 1415,
	"./Cactus_biznaga_red_flower_07.jpg": 7132,
	"./Cactus_biznaga_red_flower_08.jpg": 715,
	"./Cactus_yellow_flower_01.jpg": 1748,
	"./Cactus_yellow_flower_03.jpg": 7754,
	"./Cactus_yellow_flower_05.jpg": 4361,
	"./Cactus_yellow_flower_10.jpg": 3497,
	"./Cactus_yellow_flower_12.jpg": 6566,
	"./Dafodil_pollen_01.jpg": 3464,
	"./Dafodil_pollen_03.jpg": 7588,
	"./Dafodil_pollen_04.jpg": 7521,
	"./Dafodil_pollen_05.jpg": 8613,
	"./Dafodil_pollen_07.jpg": 5219,
	"./Dafodil_pollen_10.jpg": 8264,
	"./Lupine_Pollen_01.jpg": 4032,
	"./Lupine_Pollen_02.jpg": 2127,
	"./Lupine_Pollen_04.jpg": 228,
	"./Lupine_Pollen_05.jpg": 3883,
	"./Lupine_Pollen_07.jpg": 2333,
	"./Morning_glory_04.jpg": 9843,
	"./Morning_glory_05.jpg": 4572,
	"./Morning_glory_06.jpg": 4257,
	"./Morning_glory_07.jpg": 6270,
	"./Pink_hibiscus_01.jpg": 7738,
	"./Pink_hibiscus_02.jpg": 5618,
	"./Pink_hibiscus_04.jpg": 6679,
	"./Pink_hibiscus_05.jpg": 8211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2800;